import React, { useCallback, useRef } from "react";

import Button, { ButtonColor } from "components/shared/button";
import {
  StyledExpanderWrapper,
  StyledExpanderContent,
} from "components/shared/dropdown_expander";
import Icon, { ICON_TYPE, ICON_COLOR } from "components/shared/icon";
import FiltersContainer from "containers/schedule/action_bar/filters_container";
import { trackEvent } from "helpers/analytics";
import useOnDocumentClick from "helpers/hooks/useOnDocumentClick";
import useOnEscapeKey from "helpers/hooks/useOnEscapeKey";
import useToggle from "helpers/hooks/useToggle";

interface IFiltersButton {
  hasFiltersApplied: boolean;
}

export default function FiltersButton({ hasFiltersApplied }: IFiltersButton) {
  const trackExpandEvent = useCallback(
    (newValue: boolean) =>
      trackEvent(`Toolbar - Button - Filter - ${newValue ? "Open" : "Close"}`),
    []
  );
  const [expanded, toggleExpanded] = useToggle(false, trackExpandEvent);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const close = useCallback(() => {
    if (expanded) {
      toggleExpanded();
    }
  }, [expanded]);
  useOnDocumentClick(close, wrapperRef);
  useOnEscapeKey(close);

  return (
    <StyledExpanderWrapper ref={wrapperRef}>
      <Button
        label="Filter"
        buttonColor={ButtonColor.BLUE}
        onClick={toggleExpanded}
        iconLeft={
          <Icon
            size="12px"
            type={ICON_TYPE.FILTER}
            color={hasFiltersApplied ? ICON_COLOR.ORANGE : ICON_COLOR.WHITE}
          />
        }
      />
      {expanded && (
        <StyledExpanderContent>
          <FiltersContainer />
        </StyledExpanderContent>
      )}
    </StyledExpanderWrapper>
  );
}
